<template>
  <div class="cancellation-container">
    <div class="cancellation-card">
      <h2 class="title">Antes de finalizar... que tal mais uma chance?</h2>

      <p class="message">
        Sabemos que você tem muitos planos e metas financeiras e queremos ajudar a tornar tudo isso mais simples de
        alcançar.
      </p>

      <div class="features">
        <p class="feature-title">O <b>Meu Futuro</b> oferece as ferramentas ideais para você gerenciar suas finanças com clareza e praticidade, incluindo:</p>
        <ul>
          <li><b>Organização das suas finanças pessoais</b> - acompanhe seus ganhos e gastos em um único lugar.</li>
          <li><b>Mural de sonhos</b> - defina seus objetivos e visualize seu progresso rumo a eles.</li>
          <li><b>Linha do Futuro</b> - um acompanhamento contínuo das suas metas, com ajustes conforme necessário para que você sempre siga no caminho certo.</li>
        </ul>
      </div>

      <p class="message">
        Agora, queremos te dar mais uma chance de aproveitar o nosso app e garantir o controle total das suas finanças.<br>
        Estamos oferecendo 3 meses grátis para você continuar utilizando o app e explorar todas as suas funcionalidades.
      </p>

      <div class="action-buttons">
        <button class="btn btn-primary" @click="$emit('activate-free-months')">
          Quero aproveitar os 3 meses grátis.
        </button>
        <button class="btn btn-danger" @click="$emit('confirm-cancellation')" :disabled="processing">
          {{ processing ? 'Processando...' : 'Cancelar agora' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CancellationConfirmation',
  props: {
    processing: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.cancellation-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.cancellation-card {
  border-radius: 10px;
  padding: 30px;
  max-width: 600px;
  width: 100%;
}

.title {
  color: #fff;
  font-size: 28px;
  margin-bottom: 20px;
  text-align: center;
}

.message {
  color: #e4e4e4;
  font-size: 16px;
  margin-bottom: 30px;
  line-height: 1.5;
  text-align: center;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap;
}

.btn {
  padding: 12px 24px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  min-width: 220px;
}

.btn-primary {
  background-color: #cb5540;
  color: white;
  border: none;
}

.btn-primary:hover {
  background-color: #a8473a;
}

.btn-danger {
  background-color: #283045;
  color: #e4e4e4;
  border: 1px solid #e4e4e4;
}

.btn-danger:hover:not([disabled]) {
  background-color: rgba(255, 255, 255, 0.1);
}

.btn[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}

.features {
  background-color: #1e2433;
  padding: 20px;
  border-radius: 8px;
  margin: 20px 0;
}

.feature-title {
  color: #fff;
  font-size: 18px;
  margin-bottom: 15px;
  font-weight: 500;
}

.check {
  color: #4caf50;
  margin-right: 10px;
}

.feature {
  color: #e4e4e4;
  font-size: 16px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
</style>
